import { Lock, LockOpen } from "@mui/icons-material";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default ({
  enabled, titleEnabled = "", titleDisabled = "", disabled = false, buttonSize = "medium", fontSize = "small",
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (enabled === true) {
    return (
      <Tooltip title={t(titleEnabled)} placement="bottom" disableTouchListener>
        <div style={{ display: "inline-flex" }}>
          <IconButton disabled={disabled} size={buttonSize}>
            <LockOpen fontSize={fontSize} style={{ color: theme.palette.success.light }} />
          </IconButton>
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t(titleDisabled)} placement="bottom" disableTouchListener>
      <div style={{ display: "inline-flex" }}>
        <IconButton disabled={disabled} size={buttonSize}>
          <Lock fontSize={fontSize} style={{ color: theme.palette.error.light }} />
        </IconButton>
      </div>
    </Tooltip>
  );

};
